import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import ActionPlanTypeCell from "pages/Corporate/RCA/RCAActionPlans/useRCAActionPlansColumns/components/ActionPlanTypeCell";
import ActionPlanIssueOrRCACell from "pages/Corporate/RCA/RCAActionPlans/useRCAActionPlansColumns/components/ActionPlanIssueOrRCACell";
import ActionPlanDescriptionCell from "pages/Corporate/RCA/RCAActionPlans/useRCAActionPlansColumns/components/ActionPlanDescriptionCell";
import ActionPlanDueDateCell from "pages/Corporate/RCA/RCAActionPlans/useRCAActionPlansColumns/components/ActionPlanDueDateCell";
import ActionPlanStatusCell from "pages/Corporate/RCA/RCAActionPlans/useRCAActionPlansColumns/components/ActionPlanStatusCell";

interface IMyActionPlansColumns extends Omit<IMainTableColumn, "render" | "renderExpandedRow"> {
    render: (row: IActionPlan) => string | JSX.Element | number;
}

const useMyActionPlansColumns = () => {
    const { t } = useTranslation();

    const columns = useMemo((): IMyActionPlansColumns[] => {
        return [
            {
                id: "number",
                label: t("rca.action_plans.plan_number"),
                hideSortIcon: false,
                customStyles: { width: "10%" },
                render: (row) => <ActionPlanTypeCell actionPlan={row} />,
            },
            {
                id: "type",
                label: `${t("rca.rca_dashboard.issue")}/${t("rca.rca_dashboard.rca")}`,
                hideSortIcon: false,
                customStyles: { width: "10%" },
                render: (row) => <ActionPlanIssueOrRCACell actionPlan={row} />,
            },
            {
                id: "name",
                label: t("rca.action_plans.name"),
                hideSortIcon: false,
                customStyles: { width: "39%" },
                render: (row) => <ActionPlanDescriptionCell actionPlan={row} />,
            },
            {
                id: "due_date",
                label: t("rca.rca_library.due_date"),
                hideSortIcon: false,
                align: "center",
                customStyles: { width: "20%" },
                render: (row) => <ActionPlanDueDateCell actionPlan={row} />,
            },
            {
                id: "status",
                label: t("rca.rca_library.status"),
                headerCustomStyles: { textAlign: "right", paddingRight: "80px" },
                hideSortIcon: false,
                customStyles: { width: "20%" },
                render: (row) => <ActionPlanStatusCell myDashboard actionPlan={row} />,
            },
        ];
    }, [t]);

    return columns;
};

export default useMyActionPlansColumns;
